import { AxiosResponseHeaders } from 'axios';
import { CardDetailsResponseBody } from '../../../types';
import { CardDetails, CardDetailsResponseDTO } from '../entities/CardDetails';

const cardDetailsResponseDTOToCardDetailsAdapter = (
  data: CardDetailsResponseDTO,
  headers?: AxiosResponseHeaders,
): CardDetailsResponseBody => {
  if (!data.body) {
    throw new Error();
  }

  const cardDetails = data.body;
  return new CardDetails(
    cardDetails.cardName,
    '***',
    cardDetails.cardProduct.title,
    cardDetails.paymentCardIdentifications,
    cardDetails.type,
    cardDetails.maskedCardNumber,
    cardDetails.startDate,
    cardDetails.expiryDate,
    cardDetails.virtual,
    cardDetails.balances,
    cardDetails.status,
    cardDetails.cardProduct,
    cardDetails.cardNetwork,
  );
};

export { cardDetailsResponseDTOToCardDetailsAdapter };
